import React from 'react';
import { Spin, Empty, Button, Card, Table } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import MarketMatrixHeatmap from '../MarketMatrixHeatmap';

interface MarketMatrixTabProps {
  matrixData: any;
  loading: boolean;
  onExport: () => void;
}

/**
 * 市场矩阵分类Tab组件
 * 展示9宫格热力图和市场类型分布统计
 */
export const MarketMatrixTab: React.FC<MarketMatrixTabProps> = ({
  matrixData,
  loading,
  onExport,
}) => {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" tip="正在加载市场矩阵数据...">
          <div style={{ minHeight: 100 }} />
        </Spin>
      </div>
    );
  }

  if (!matrixData) {
    return <Empty description="暂无市场矩阵数据" />;
  }

  return (
    <div style={{ padding: '20px 0' }}>
      <div style={{ marginBottom: 24 }}>
        <Button 
          type="primary" 
          icon={<DownloadOutlined />}
          onClick={onExport}
        >
          导出增强版Excel报告
        </Button>
      </div>

      <Card title="市场矩阵9宫格分布" style={{ marginBottom: 24 }}>
        <MarketMatrixHeatmap data={matrixData.matrix} />
        <div style={{ textAlign: 'center', marginTop: 16, color: '#666' }}>
          总关键词数: {matrixData.total_keywords}
        </div>
      </Card>

      <Card title="市场类型分布统计">
        <Table
          dataSource={matrixData.distribution}
          rowKey="market_type"
          pagination={false}
          columns={[
            {
              title: '市场类型',
              dataIndex: 'market_type',
              key: 'market_type',
              width: 150,
            },
            {
              title: '关键词数量',
              dataIndex: 'keyword_count',
              key: 'keyword_count',
              width: 120,
              sorter: (a: any, b: any) => a.keyword_count - b.keyword_count,
            },
            {
              title: '占比(%)',
              dataIndex: 'percentage',
              key: 'percentage',
              width: 100,
              render: (val: number) => `${val.toFixed(1)}%`,
            },
            {
              title: '市场建议',
              dataIndex: 'recommendation',
              key: 'recommendation',
            },
          ]}
        />
      </Card>
    </div>
  );
};

